import React, { useState, useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'components/molecules'
import { PageRenderer, Toast } from 'containers';
import {
  Title, Button, Text, LoadingSpinner, Spacer,
} from 'components/atoms'
import { getVersion } from 'services/requests'
import { generateReadablePtDate } from 'services/generators'
import { toast } from 'react-toastify';
import styled from 'styled-components/macro'
import { computeHasModules } from 'modules/utils'

const PageVersionModal = ({
  isOpen,
  toggle,
  commit,
  pageId,
  subweb,
  versionId,
  statusId,
  onSetVersion
}) => {
  const [page, setPage] = useState([])
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    async function fetchVersion() {
      try {
        setLoading(true)
        const { data } = await getVersion({
          pageId, subweb, versionId, statusId
        })
        setPage(data)
        setLoading(false)
      } catch (err) {
        setPage([])
        setLoading(false)
        toast.error(
          <Toast
            type="error"
            title="Ocorreu um erro a carregar a pré-visualização"
            description={err.message}
          />
        );
      }
    }
    if (subweb && pageId && versionId && statusId) {
      fetchVersion()
    }
  }, [subweb, pageId, versionId, statusId])

  const pageHasModules = useMemo(
    () => (page.length > 0 ? computeHasModules(page) : false),
    [page]
  )

  const dateComputed = useMemo(() => (commit && commit.date ? generateReadablePtDate(commit.date) : 'Sem informação'), [commit])

  const renderPage = () => {
    if (isLoading) {
      return (
        <PageWrapper>
          <PageNoContent>
            <LoadingSpinner />
          </PageNoContent>
        </PageWrapper>
      )
    }
    return (
      <PageWrapper>
        {(pageHasModules)
          ? <PageRenderer page={page} isPreview />
          : (
            <PageNoContent>
              <Text>
            Página sem conteúdo.
              </Text>
            </PageNoContent>
          )
        }
      </PageWrapper>
    )
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <Modal.Top smallSpacing>
        <Title>
            Pré-visualizar versão
          <Spacer top="xs" />
          {commit && commit.date && (
            <Text modifiers={['light']}>
              {commit.actions && commit.actions[0] && commit.actions[0].description && (
                `${commit.actions[0].description} às `
              )}
              {dateComputed}
            </Text>
          )
          }
        </Title>
      </Modal.Top>
      {renderPage()}
      <Modal.Actions>
        <Button
          type="button"
          modifiers={['marginRight', 'capitalize']}
          onClick={toggle}
        >
          Cancelar
        </Button>
        <Button
          type="submit"
          modifiers={['primary', 'capitalize']}
          onClick={() => onSetVersion(page)}
          loading={isLoading}
        >
          Restaurar
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

PageVersionModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  pageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  versionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  statusId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  subweb: PropTypes.string.isRequired,
  commit: PropTypes.shape({
    date: PropTypes.string.isRequired,
    user: PropTypes.shape({
      name: PropTypes.string,
      image: PropTypes.string,
    }),
    actions: PropTypes.arrayOf(PropTypes.shape({
      description: PropTypes.string.isRequired,
    })),
  }),
  onSetVersion: PropTypes.func,
}

PageVersionModal.defaultProps = {
  isOpen: false,
  toggle: () => { },
  commit: {
    user: {
      name: null,
      image: null,
    },
    actions: [],
  },
  onSetVersion: () => {}
}

const PageWrapper = styled.div`
  border: 1px solid ${props => props.theme.colors.border};
`

const PageNoContent = styled.div`
  padding: ${props => props.theme.spacing.xl6} 0;
  display: flex;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
`

export default PageVersionModal
